import { render, staticRenderFns } from "./MarketingCollectionsBlock.vue?vue&type=template&id=339d7ef0&scoped=true&"
import script from "./MarketingCollectionsBlock.vue?vue&type=script&lang=js&"
export * from "./MarketingCollectionsBlock.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCollectionsBlock.vue?vue&type=style&index=0&id=339d7ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339d7ef0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
